function mhFilterCount(){
    // Běžné filtry: <label>Název <span class="filter-count">12</span></label>
    // počet vyjmeme z labelu a dáme ho za něj, v labelu zůstane jen název
    $('.filter-section label.filter-label').each(function(){
        var $label = $(this);
        var $count = $label.find('.filter-count');
        if(!$count.length) return;
        $count.insertAfter($label);
    });

    // Barvy: <span class="sr-only">Modrá (372)</span> → název + zvlášť .filter-count
    $('.advanced-filters-wrapper label.advanced-parameter > .sr-only').each(function(){
        var $text = $(this);
        var match = $text.text().trim().match(/^(.*?)\s*\((\d+)\)$/);
        if(!match) return;
        $text.text(match[1]);
        $('<span class="filter-count"></span>').text(match[2]).insertAfter($text.closest('label'));
    });
}

$(document).ready(function() {
    mhFilterCount();
});
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhFilterCount();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    mhFilterCount();
});
